import lodash from 'lodash';
import { objectFlat } from 'utils/util';
import { currencyBankMap } from '../helper';
import { ChoiceBankType, ChoiceItemInfo } from '../type';

export const parseBankInfo = (choiceList, currency, bankId) => {
    const currentCurrency = choiceList[currency] ? currency : Object.keys(choiceList)[0];
    const currentChoiceOptions = choiceList[currentCurrency];

    const cloneDeep: ChoiceItemInfo[] = lodash.clone(currentChoiceOptions);

    // 将银行数据进行拍平处理
    const allBankMap = objectFlat(
        currentChoiceOptions,
        value => Array.isArray(value),
        ({ childAcc, childKey, key, separator, flattenedChild }) => {
            if (flattenedChild.length === 1) {
                return {
                    ...childAcc,
                    [`${key}${separator}${childKey}`]: { ...flattenedChild[childKey], isOnly: true }
                };
            }

            return { ...childAcc, [`${key}${separator}${childKey}`]: flattenedChild[childKey] };
        }
    );

    // // 将拍平的银行数据处理成数组，并携带 type，（全部的银行列表）
    const allBankList = lodash.keys(allBankMap).map(key => Object.assign({ key: key[0] }, allBankMap[key]));

    // 每个银行类型下只取第一个银行
    lodash.keys(currentChoiceOptions).forEach(t => {
        cloneDeep[t] = cloneDeep[t][0];
    });

    // 过滤后的银行数据的 key list，然后进行排序
    const depositBankKeyList = Object.keys(cloneDeep);

    // 默认当前币种对应银行为第一位
    depositBankKeyList.sort(t => (Number(t[0]) === currencyBankMap[currentCurrency] ? -1 : 1));

    // 选择在选择框中的数据（过滤后，每种银行只取第一个）
    const depositBankList: Array<ChoiceItemInfo & { key: ChoiceBankType }> = depositBankKeyList.map(key =>
        Object.assign({ key }, cloneDeep[key])
    );

    const queryBankId = allBankList.find(t => String(t.id) === String(bankId)) ? bankId : null;
    // 先根据链接，仅有一个时仅跳转第一个，再找缓存，然后根据居住国找的银行，最后默认第一个
    const tmpBankId =
        queryBankId || (depositBankList.length === 1 ? depositBankList[0].id : false) || depositBankList[0].id;

    return {
        depositBankList,
        allBankList,
        currency: currentCurrency,
        id: tmpBankId
    };
};
